import {copyText, el} from "./progress"

const STREAMS = [
  {key: "transactional", prefix: "mail", cluster: "Transactional cluster", sending: true},
  {key: "notifications", prefix: "notify", cluster: "Transactional cluster", sending: true},
  {key: "bulk", prefix: "news", cluster: "Bulk cluster", sending: true},
  {key: "receiving", prefix: "inbound.mail", cluster: "Transactional cluster", sending: false}
]

function normaliseDomain(value) {
  let host = String(value || "").trim().toLowerCase()
  host = host.replace(/^[a-z][a-z0-9+.-]*:\/\//, "")
  host = host.split("/")[0]
  host = host.split("?")[0]
  host = host.split("#")[0]
  host = host.replace(/:\d+$/, "")
  host = host.replace(/^\.+|\.+$/g, "")
  return host || "example.com"
}

function enabledStreams(root) {
  return STREAMS.filter((stream) => {
    return root.querySelector(`[data-learn-stream='${stream.key}'][aria-pressed='true']`)
  })
}

function hostFor(stream, domain) {
  return `${stream.prefix}.${domain}`
}

function recordsFor(stream, domain, includeDmarc) {
  const host = hostFor(stream, domain)
  const rows = []
  if (stream.sending) {
    rows.push({
      record: `CNAME <selector>._domainkey.${host}`,
      note: "DKIM target from the domain page"
    })
    rows.push({
      record: `CNAME rp.${host}`,
      note: "Return-path target from the domain page"
    })
  } else {
    rows.push({
      record: `MX ${host}`,
      note: "MX target from the inbox page"
    })
  }
  if (includeDmarc) {
    rows.push({
      record: `TXT _dmarc.${domain}`,
      note: "v=DMARC1; p=none;"
    })
  }
  return rows
}

function recordItem(row) {
  const item = el("li")
  item.append(el("p", "break-all font-mono text-[12px] leading-5 text-ink", row.record))
  item.append(el("p", "mt-0.5 break-all text-[12px] leading-5 text-ink-subtle", row.note))
  if (row.note.startsWith("v=DMARC1")) {
    item.lastChild.classList.add("font-mono")
  }
  return item
}

function streamCard(stream, domain, includeDmarc, open) {
  const host = hostFor(stream, domain)
  const card = el("div", "rounded-xl bg-surface-overlay px-4 py-3 shadow-mock")
  card.append(el("p", "break-all font-mono text-[13px] text-ink", host))
  card.append(el("p", "mt-1 text-[13px] text-ink-muted", stream.cluster))
  const details = el("details", "group mt-2")
  if (open) details.open = true
  const summary = el("summary", "cursor-pointer list-none text-[13px] font-medium text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 [&::-webkit-details-marker]:hidden", "DNS records")
  const list = el("ul", "mt-2 space-y-2")
  recordsFor(stream, domain, includeDmarc).forEach((row) => list.append(recordItem(row)))
  details.append(summary, list)
  card.append(details)
  return card
}

function copyList(streams, domain) {
  const lines = []
  streams.forEach((stream, index) => {
    const host = hostFor(stream, domain)
    lines.push(host)
    lines.push(stream.cluster)
    recordsFor(stream, domain, index === 0).forEach((row) => {
      lines.push(row.record)
      lines.push(row.note)
    })
    lines.push("")
  })
  return lines.join("\n").trim()
}

function render(root) {
  const domain = normaliseDomain(root.querySelector("[data-learn-domain]")?.value)
  const streams = enabledStreams(root)
  const map = root.querySelector("[data-learn-map]")
  if (!map) return
  map.replaceChildren()
  if (!streams.length) {
    map.append(el("p", "text-[13px] leading-5 text-ink-muted", "Turn on a stream to see its host."))
    return
  }
  streams.forEach((stream, index) => {
    map.append(streamCard(stream, domain, index === 0, index === 0))
  })
}

export function mount(root) {
  const live = root.querySelector("[data-learn-copy-status]")
  root.querySelectorAll("[data-learn-stream]").forEach((button) => {
    button.addEventListener("click", () => {
      button.setAttribute("aria-pressed", String(button.getAttribute("aria-pressed") !== "true"))
      render(root)
    })
  })
  const input = root.querySelector("[data-learn-domain]")
  input?.addEventListener("input", () => render(root))
  input?.addEventListener("blur", () => {
    input.value = normaliseDomain(input.value)
    render(root)
  })
  root.querySelector("[data-learn-copy]")?.addEventListener("click", () => {
    const domain = normaliseDomain(root.querySelector("[data-learn-domain]")?.value)
    copyText(copyList(enabledStreams(root), domain), live, "Copied.")
  })
  render(root)
}
